import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

Vue.component('apexchart', window.VueApexCharts)

Vue.config.productionTip = false

const vuetifyOptions = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#4318FF',
        accent: '#1B2559',
        secondary: '#A3AED0',
        background: '#F4F7FE',
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  vuetify: vuetifyOptions,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js